import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { apiBaseUrl } from '../../configs/configs';
import { Table } from "reactstrap";

function UserWinning(props) {
    const { prediction_id } = props.match.params;
    const [userWinning, setUserWinning] = useState([])
    const getWinningSetForThisUser = async () => {
        const result = await axios.get(`${apiBaseUrl}/get_prediction_winning/${prediction_id}`)
        if(result.data.status === 'success'){
            setUserWinning(result.data.data)
        }
    }
    useEffect(() => {
        getWinningSetForThisUser()
    },[])
    return (
    <div>
        <Table>
            <thead>
                <tr>
                    <th>user_id</th>
                    <th>team_name</th>
                    <th>rank</th>
                    <th>option</th>
                    <th>win_price</th>
                </tr>
            </thead>
            <tbody>
                {userWinning.map(data => <tr>
                    <td>{data.user_id}</td>
                    <td>{data.team_name}</td>
                    <td>{data.rank}</td>
                    <td>{data.option}</td>
                    <td>{data.win_price}</td>
                </tr>)

                }
            </tbody>
        </Table>
    </div>
  )
}

export default UserWinning